export default {
	path: '/renew-main',
	redirect: '/renew-main',
	component: () => import('@/views/layout/Default.renew'),
	children: [
		{
			path: '/',
			name: 'renewMainHome',
			component: () => import('@/views/main/RenewMain'),
		},
	],
};
